export const privacy = {
  title: 'プライバシーポリシー',
  
  article1: {
    title: '第1条(取得する情報)',
    item1: '氏名またはニックネーム',
    item2: 'メールアドレス',
    item3: '学習言語、語学レベル、学習目的',
    item4: '利用履歴、参加日時、セッション関連データ(録画・テキスト化情報を含む場合があります)',
    item5: '決済に関する情報(クレジットカード番号等は決済代行事業者が管理し、運営は保持しません)'
  },
  
  article2: {
    title: '第2条(利用目的)',
    item1: '本サービスの提供、マッチング、運営管理',
    item2: '利用者への連絡、通知、サポート対応',
    item3: 'サービス品質の向上、分析、統計処理',
    item4: '規約違反、不正行為、トラブルへの対応',
    item5: '法令または行政機関の要請への対応'
  },
  
  article3: {
    title: '第3条(第三者提供および委託)',
    point1: '運営は、法令に基づく場合を除き、本人の同意なく個人情報を第三者に提供しません。',
    point2: 'ただし、決済、システム運用、通信等を外部事業者に委託する場合があります。'
  },
  
  article4: {
    title: '第4条(国際的なデータ移転)',
    point1: '本サービスは国際的に提供されるため、個人情報は日本および海外(例:カナダ)において保存・処理される場合があります。',
    point2: '当該データの取扱いについては、日本法および本ポリシーに基づき管理されます。'
  },
  
  article5: {
    title: '第5条(安全管理措置)',
    content: '運営は、個人情報の漏えい、滅失、改ざん等を防止するため、合理的な技術的および組織的安全管理措置を講じます。'
  },
  
  article6: {
    title: '第6条(利用者の権利)',
    content: '利用者は、自己の個人情報について、法令に基づき、開示、訂正、削除、利用停止等を求めることができます。ただし、運営の正当な業務遂行に必要な情報については、請求に応じられない場合があります。'
  },
  
  article7: {
    title: '第7条(Cookieなどの利用)',
    content: '運営は、利便性向上および利用状況分析のため、Cookieその他の類似技術を使用する場合があります。'
  },
  
  article8: {
    title: '第8条(保存期間)',
    content: '個人情報は、利用目的に必要な期間保持し、その後適切な方法で削除または匿名化します。'
  },
  
  article9: {
    title: '第9条(ポリシーの変更)',
    content: '本ポリシーは、法令またはサービス内容の変更に応じて、事前の通知なく改定されることがあります。'
  }
};
